export default "__VITE_ASSET__CGt5fUi___"